











import { Vue, Component } from 'vue-property-decorator';
import { Getter, Action, Mutation, State } from 'vuex-class';

import { Spinner, IconButton } from '@components/UI';
import { Post, PollPost } from '@components/Posts';

@Component({
    components: { Post, Spinner, PollPost, IconButton }
})
export default class VueStream extends Vue { 
    @Action
    public loadPollStream: () => Promise<any>;

    @Getter
    public pollStream: any;

    private loading: boolean = false;
    private observer: IntersectionObserver | null;

    public async mounted() {
        this.observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting && !this.loading) {
                    this.loading = true;
                    this.loadPollStream().finally(() => this.loading = false);
                }
            })
        });

        this.observer.observe(this.$refs.trigger as HTMLElement);
    }

    public beforeDestroy() {
        if (this.observer) {
            this.observer.unobserve(this.$refs.trigger as HTMLElement);
            this.observer.disconnect();
            this.observer = null;
        }
    }
}

